import * as DialogRadix from '@radix-ui/react-dialog';
import { Cross2Icon } from '@radix-ui/react-icons';
import React, { Dispatch, ReactNode, SetStateAction } from 'react';

type DialogProps = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  title?: string;
  description?: string;
  children: ReactNode;
  isClosable?: boolean;
  width?: number;
};

const Dialog = ({
  isOpen,
  setIsOpen,
  title,
  description,
  children,
  isClosable = true,
  width
}: DialogProps) => {
  return (
    <DialogRadix.Root open={isOpen} onOpenChange={setIsOpen}>
      <DialogRadix.Portal>
        <div className="tw-fixed tw-inset-0 tw-bg-gray-500 tw-bg-opacity-75 tw-transition-opacity"></div>
        <DialogRadix.Content className="data-[state=open]:animate-contentShow tw-fixed tw-top-[50%] tw-left-[50%] tw-max-h-[85vh] tw-w-[90vw] tw-max-w-[450px] tw-translate-x-[-50%] tw-translate-y-[-50%] tw-rounded-[1rem] tw-bg-white tw-p-[25px] tw-shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] tw-focus:outline-none">
          <DialogRadix.Title className="tw-text-mauve12 tw-text-center tw-m-0 tw-text-[17px] tw-font-medium">
            {title}
          </DialogRadix.Title>
          <DialogRadix.Description className="tw-text-mauve11 tw-mt-[10px] tw-mb-5 tw-text-[15px] tw-leading-normal">
            {description}
          </DialogRadix.Description>
          {children}
          {isClosable ? (
            <DialogRadix.Close asChild>
              <button
                className="tw-text-violet11 tw-hover:bg-violet4 tw-focus:shadow-violet7 tw-absolute tw-top-[10px] tw-right-[10px] tw-inline-flex tw-h-[25px] tw-w-[25px] tw-appearance-none tw-items-center tw-justify-center tw-rounded-full tw-focus:shadow-[0_0_0_2px] tw-focus:outline-none"
                aria-label="Close"
              >
                <Cross2Icon />
              </button>
            </DialogRadix.Close>
          ) : null}
        </DialogRadix.Content>
      </DialogRadix.Portal>
    </DialogRadix.Root>
  );
};

export default Dialog;
